
import { Label } from '@/model';
import { notEmpty } from '@/util/array-util';
import Vue from 'vue';
import LabelChip from './LabelChip.vue';

export default Vue.extend({
  name: 'LabelPanel',
  components: { LabelChip },

  props: {
    labels: { type: Array as () => Array<Label>, default: () => [] },
    limit: { type: Boolean, default: false },
    limitSize: { type: Number, default: 3 },
    large: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    closeIcon: { type: String },
    column: { type: Boolean, default: false },
    disabledLabels: { type: Array as () => Array<number>, default: () => [] },
  },

  computed: {
    ls() {
      return this.labels.filter(notEmpty);
    },

    showLabels(): Label[] {
      return this.limit ? this.ls.slice(0, this.limitSize) : this.ls;
    },
    tooltipLabels(): Label[] {
      return this.limit ? this.ls.slice(this.limitSize) : this.ls;
    },
  },

  methods: {
    disabled(label: Label): boolean {
      return this.disabledLabels.some((l) => l === label.id);
    },
  },
});
